@if (hasHeatMeter$ | async) {
  <app-multi-value-tile
    [tileTitle]="'heat-meter-tile.title' | translate"
    [lastUpdated]="lastUpdated$ | async"
    [values]="values$ | async"
    [installationId]="(installation$ | async)?.id"
    [applicationId]="application.id">
  </app-multi-value-tile>
}
